module.exports = __webpack_public_path__ + "media/images/small_image_mock-6cc963f677b4d1413eb3fbf430d903cc.jpg";